import { memo, useEffect } from 'react'
import { useInterceptors } from 'commons/customHooks/useInterceptors'
import { toFirsLetterUpper } from 'commons/utils/string'

export const originalSetItem = localStorage.setItem

export const asyncLocalStorage = {
  setItem: async (key: string, value: string) => {
    await null
    return localStorage.setItem(key, value)
  },
  getItem: async (key: string) => {
    await null
    return localStorage.getItem(key)
  },
  removeItem: async (key: string) => {
    await null
    return localStorage.removeItem(key)
  }
}

localStorage.setItem = function (key, value) {
  const event = new StorageEvent('itemInserted', { key, newValue: value })
  document.dispatchEvent(event)
  const newArguments: [key: string, value: string] = [key, value]

  originalSetItem.apply(this, newArguments)
}

export const LocalStorageChangesListenerComponent = () => {
  const {
    serverErrorModal,
    setServerErrorModal,
    timeoutTime,
    setModalMessage,
    setModalTitleErrorMessage,
    ErrorGenericMessage
  } = useInterceptors()

  const handleErrorTitleAndMessage = (storageModalErrorMessage: {
    title: string
    message: string
  }) => {
    const modalTitle: string = storageModalErrorMessage?.title
      ? toFirsLetterUpper(storageModalErrorMessage?.title)
      : ErrorGenericMessage?.title || ''
    const newModalMessage: string = storageModalErrorMessage?.message
      ? storageModalErrorMessage.message
      : ErrorGenericMessage?.message || ''
    setModalMessage(newModalMessage)
    setModalTitleErrorMessage(modalTitle)
    setTimeout(() => {
      localStorage.removeItem('serverErrorModal')
    }, timeoutTime)
  }

  const handleAPIErrors = () => {
    const error = localStorage.getItem('serverErrorModal')
    const errorFirstTime = asyncLocalStorage.getItem('serverErrorModal')
    const modalErrorMessage = localStorage.getItem('serverErrorModalMessage')

    if (!error && !serverErrorModal) {
      setServerErrorModal(true)
    }

    if (modalErrorMessage)
      if (error) {
        const storageError = JSON.parse(error)
        const storageModalErrorMessage = JSON.parse(modalErrorMessage)
        if (storageError.open) {
          handleErrorTitleAndMessage(storageModalErrorMessage)
        }
      } else {
        errorFirstTime.then((value) => {
          const storageError = JSON.parse(value as string)
          const storageModalErrorMessage = JSON.parse(modalErrorMessage)
          if (storageError.open) {
            handleErrorTitleAndMessage(storageModalErrorMessage)
          }
        })
      }
  }

  const localStorageSetHandler = (event: StorageEvent | Event) => {
    if ('key' in event) {
      if (event.key === 'serverErrorModal') {
        handleAPIErrors()
      }
    }
  }

  useEffect(() => {
    document.addEventListener('itemInserted', localStorageSetHandler, false)
  }, [])

  return <></>
}

export const LocalStorageChangesListener = memo(LocalStorageChangesListenerComponent)
